'use strict';

var log = require('../../log/Log').channel('UpdateController');

/* global FileTransfer */
/* global FileTransferError */

var FileDownloader = {
    download: download,
};

function convertFileTransferErrorCodeToString(code) {
    switch (code) {
        case FileTransferError.FILE_NOT_FOUND_ERR:
            return 'FILE_NOT_FOUND_ERR';
        case FileTransferError.INVALID_URL_ERR:
            return 'INVALID_URL_ERR';
        case FileTransferError.CONNECTION_ERR:
            return 'CONNECTION_ERR';
        case FileTransferError.ABORT_ERR:
            return 'ABORT_ERR';
        case FileTransferError.NOT_MODIFIED_ERR:
            return 'NOT_MODIFIED_ERR';
        default:
            return 'UNKNOWN_ERR';
    }
}

function download(src, dest, onProgress) {
    var fileTransfer = new FileTransfer();

    fileTransfer.onprogress = function(progressEvent) {
        if (progressEvent.lengthComputable) {
            if (onProgress) {
                onProgress(progressEvent.loaded / progressEvent.total);
            }
        }
    };

    return new Promise(function(resolve, reject) {
        fileTransfer.download(src, dest, function(fileEntry) {
            fileEntry.file(function(fileObj) {
                log.debug('downloaded ' + fileEntry.toURL() + '; size = ' + fileObj.size);
                resolve();
            });
        }, function(err) {
            log.error('failed downloading ' + src + ' to ' + dest +
                ', error code: ' + convertFileTransferErrorCodeToString(err.code) +
                (typeof err.exception === 'undefined' ? '' : ', exception: ' + err.exception.toString()));
            reject();
        }, false); // don't trust all hosts (aka self-signed)
    });
}

module.exports = FileDownloader;
